// import React, { useState, useEffect } from "react";
// import {
//   Card,
//   Input,
//   Button,
//   Select,
//   Table,
//   Tag,
//   Space,
//   Tooltip,
//   Modal as AntModal,
//   message as antdMessage,
// } from "antd";
// import {
//   EyeOutlined,
//   EditOutlined,
//   DeleteOutlined,
//   PoweroffOutlined,
//   CopyOutlined,
//   MessageOutlined,
// } from "@ant-design/icons";
// import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/style.css";
// import dayjs from "dayjs";
// import Modal from "../../components/Modal";
// import { useGet, usePost, useDynamicApi } from "../../hooks/useApi";
// import { useDebounce } from "../../hooks/useDebounce";
// import { API_ENDPOINTS } from "../../config/api";
// import Toast from "../../utils/toast";
// import { useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";

// const { Option } = Select;

// const ClubMigrateManager = () => {
//   const { t, i18n } = useTranslation();
//   const navigate = useNavigate();

//   // Modal states
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
//   const [selectedItem, setSelectedItem] = useState(null);
//   const [itemToDelete, setItemToDelete] = useState(null);
//   const [isEditMode, setIsEditMode] = useState(false);

//   // Send Message Modal states
//   const [isSendMessageModalOpen, setIsSendMessageModalOpen] = useState(false);
//   const [sendMessageRecord, setSendMessageRecord] = useState(null);
//   const [sendMessageForm, setSendMessageForm] = useState({
//     country_code: "+31",
//     mobile: "",
//   });
//   const [sendingMessage, setSendingMessage] = useState(false);
//   const [sendMessageErrors, setSendMessageErrors] = useState({});

//   // Form data state
//   const [formData, setFormData] = useState({
//     club: "",
//     assigned_slots: 0,
//     free_until: null,
//     is_active: true,
//   });

//   // Form validation errors
//   const [formErrors, setFormErrors] = useState({});

//   // Filter states
//   const [searchTerm, setSearchTerm] = useState("");
//   const [statusFilter, setStatusFilter] = useState("");

//   const debouncedSearchTerm = useDebounce(searchTerm, 500);

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [totalCount, setTotalCount] = useState(0);

//   // Data states
//   const [clubMigrateList, setClubMigrateList] = useState([]);
//   const [clubsList, setClubsList] = useState([]);
//   const [loadingClubs, setLoadingClubs] = useState(false);
//   const [submitting, setSubmitting] = useState(false);

//   // Constants
//   const STATUS_OPTIONS = [
//     { value: "active", label: t("common.active") },
//     { value: "inactive", label: t("common.inactive") },
//   ];

//   // API hooks
//   const { execute: fetchList, loading: loadingList } = useGet(
//     `${API_ENDPOINTS.CLUB_MIGRATE_LIST}?page=${currentPage}&page_size=${pageSize}&search=${debouncedSearchTerm}&status=${statusFilter || ""}`,
//   );

//   const { post, loading: creating } = usePost(
//     API_ENDPOINTS.CLUB_MIGRATE_CREATE,
//   );
//   const { execute: getById, loading: loadingById } = useDynamicApi("GET");
//   const { execute: putData, loading: updating } = useDynamicApi("PUT");
//   const { execute: patchData, loading: updatingStatus } =
//     useDynamicApi("PATCH");
//   const { execute: deleteData, loading: deleting } = useDynamicApi("DELETE");
//   const { execute: fetchClubsList } = useGet(
//     API_ENDPOINTS.CLUBS_LIST_WITHOUT_PAGINATE,
//   );
//   // Send message is a GET request with query parameters
//   const { execute: sendMessageGet, loading: sendingMessageLoading } =
//     useDynamicApi("GET");

//   // Loading state
//   const loading =
//     loadingList ||
//     loadingById ||
//     updating ||
//     updatingStatus ||
//     deleting ||
//     creating ||
//     loadingClubs ||
//     submitting ||
//     sendingMessageLoading;

//   // Load clubs list for dropdown
//   const loadClubsList = async () => {
//     setLoadingClubs(true);
//     try {
//       const response = await fetchClubsList();
//       if (response?.status === true && response.data) {
//         setClubsList(response.data);
//       } else {
//         setClubsList([]);
//       }
//     } catch (error) {
//       console.error("Error loading clubs:", error);
//       setClubsList([]);
//     } finally {
//       setLoadingClubs(false);
//     }
//   };

//   // Load club migrate data
//   const loadData = async () => {
//     try {
//       const response = await fetchList();
//       if (response) {
//         setClubMigrateList(response.data || []);
//         setTotalCount(response.pagination?.total_count || 0);
//       }
//     } catch (error) {
//       console.error("Error loading data:", error);
//     }
//   };

//   // Initial data fetch
//   useEffect(() => {
//     loadData();
//     loadClubsList();
//   }, [currentPage, pageSize]);

//   // Handle filters
//   useEffect(() => {
//     setCurrentPage(1);
//     loadData();
//   }, [debouncedSearchTerm, statusFilter]);

//   // Handle input changes
//   const handleInputChange = (field, value) => {
//     setFormData((prev) => ({ ...prev, [field]: value }));
//     if (formErrors[field]) {
//       setFormErrors((prev) => {
//         const newErrors = { ...prev };
//         delete newErrors[field];
//         return newErrors;
//       });
//     }
//   };

//   // Reset form
//   const resetForm = () => {
//     setFormData({
//       club: "",
//       assigned_slots: 0,
//       free_until: null,
//       is_active: true,
//     });
//     setFormErrors({});
//     setSelectedItem(null);
//     setIsEditMode(false);
//   };

//   // Reset filters
//   const resetFilters = () => {
//     setSearchTerm("");
//     setStatusFilter("");
//   };

//   // Validate form
//   const validateForm = () => {
//     const errors = {};

//     if (!formData.club) {
//       errors.club = t("clubMigrate.clubRequired");
//     }

//     if (
//       formData.assigned_slots === undefined ||
//       formData.assigned_slots === null ||
//       formData.assigned_slots < 0
//     ) {
//       errors.assigned_slots = t("clubMigrate.assignedSlotsRequired");
//     }

//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   // Handle create
//   const handleCreate = async (e) => {
//     e?.preventDefault?.();

//     if (!validateForm()) return;

//     setSubmitting(true);
//     try {
//       const payload = {
//         club: formData.club,
//         assigned_slots: formData.assigned_slots,
//         free_until: formData.free_until
//           ? dayjs(formData.free_until).format("YYYY-MM-DD")
//           : null,
//         is_active: formData.is_active,
//       };
//       const response = await post(payload);

//       if (response?.status === true) {
//         Toast.success(response?.message || t("clubMigrate.createdSuccess"));
//         await loadData();
//         setIsModalOpen(false);
//         resetForm();
//       } else {
//         if (response?.errors) {
//           setFormErrors(response.errors);
//         } else {
//           Toast.error(response?.message || t("clubMigrate.failedCreate"));
//         }
//       }
//     } catch (error) {
//       console.error("Error creating:", error);
//       if (error?.response?.data?.errors) {
//         setFormErrors(error.response.data.errors);
//       } else {
//         Toast.error(
//           error?.response?.data?.message ||
//             error.message ||
//             t("clubMigrate.failedCreate"),
//         );
//       }
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   // Handle update
//   const handleUpdate = async (e) => {
//     e?.preventDefault?.();

//     if (!validateForm()) return;

//     setSubmitting(true);
//     try {
//       const endpoint = `${API_ENDPOINTS.CLUB_MIGRATE_DETAIL}/${selectedItem.id}`;
//       const payload = {
//         club: formData.club,
//         assigned_slots: formData.assigned_slots,
//         free_until: formData.free_until
//           ? dayjs(formData.free_until).format("YYYY-MM-DD")
//           : null,
//         is_active: formData.is_active,
//       };
//       const response = await putData(endpoint, payload);

//       if (response?.status === true) {
//         Toast.success(response?.message || t("clubMigrate.updatedSuccess"));
//         await loadData();
//         setIsModalOpen(false);
//         resetForm();
//       } else {
//         if (response?.errors) {
//           setFormErrors(response.errors);
//         } else {
//           Toast.error(response?.message || t("clubMigrate.failedUpdate"));
//         }
//       }
//     } catch (error) {
//       console.error("Error updating:", error);
//       if (error?.response?.data?.errors) {
//         setFormErrors(error.response.data.errors);
//       } else {
//         Toast.error(
//           error?.response?.data?.message ||
//             error.message ||
//             t("clubMigrate.failedUpdate"),
//         );
//       }
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   // Toggle active status
//   const handleToggleActive = async (item) => {
//     try {
//       const newStatus = !item.is_active;
//       const endpoint = `${API_ENDPOINTS.CLUB_MIGRATE_DETAIL}/${item.id}`;
//       const response = await patchData(endpoint, { is_active: newStatus });

//       if (response?.status === true) {
//         Toast.success(
//           response?.message ||
//             (newStatus ? t("common.active") : t("common.inactive")),
//         );
//         await loadData();
//       } else {
//         Toast.error(response?.message || t("clubMigrate.failedUpdateStatus"));
//       }
//     } catch (error) {
//       console.error("Error updating status:", error);
//       Toast.error(error.message || t("clubMigrate.failedUpdateStatus"));
//     }
//   };

//   // Delete confirmation
//   const openDeleteModal = (item) => {
//     setItemToDelete(item);
//     setIsDeleteModalOpen(true);
//   };

//   const handleDeleteConfirm = async () => {
//     if (!itemToDelete) return;

//     try {
//       const endpoint = `${API_ENDPOINTS.CLUB_MIGRATE_DETAIL}/${itemToDelete.id}`;
//       const response = await deleteData(endpoint);

//       if (response?.status === true) {
//         Toast.success(response?.message || t("clubMigrate.deletedSuccess"));
//         await loadData();
//       } else {
//         Toast.error(response?.message || t("clubMigrate.failedDelete"));
//       }
//     } catch (error) {
//       console.error("Error deleting:", error);
//       Toast.error(error.message || t("clubMigrate.failedDelete"));
//     } finally {
//       setIsDeleteModalOpen(false);
//       setItemToDelete(null);
//     }
//   };

//   // Open modals
//   const openCreateModal = () => {
//     resetForm();
//     setIsEditMode(false);
//     setIsModalOpen(true);
//   };

//   const openEditModal = async (item) => {
//     try {
//       const endpoint = `${API_ENDPOINTS.CLUB_MIGRATE_DETAIL}/${item.id}`;
//       const response = await getById(endpoint);

//       if (response?.status === true && response.data) {
//         setSelectedItem(response.data);
//         setFormData({
//           club: response.data.club || "",
//           assigned_slots: response.data.assigned_slots || 0,
//           free_until: response.data.free_until
//             ? dayjs(response.data.free_until)
//             : null,
//           is_active: response.data.is_active,
//         });
//         setIsEditMode(true);
//         setIsModalOpen(true);
//       } else {
//         Toast.error(t("clubMigrate.failedFetchDetails"));
//       }
//     } catch (error) {
//       console.error("Error fetching details:", error);
//       Toast.error(error.message || t("clubMigrate.failedFetchDetails"));
//     }
//   };

//   // Navigate to view page
//   const openViewPage = (id) => {
//     navigate(`/clubmigrate/details/${id}`);
//   };

//   // Copy coupon code to clipboard
//   const handleCopyCoupon = (code) => {
//     navigator.clipboard.writeText(code);
//     antdMessage.success(t("common.copied"));
//   };

//   // Send Message modal handlers
//   const openSendMessageModal = (record) => {
//     setSendMessageRecord(record);
//     setSendMessageForm({ country_code: "+31", mobile: "" });
//     setSendMessageErrors({});
//     setIsSendMessageModalOpen(true);
//   };

//   const handlePhoneChange = (value, country) => {
//     const dialCode = `+${country.dialCode}`;
//     const mobileNumber = value.substring(country.dialCode.length);
//     setSendMessageForm({
//       country_code: dialCode,
//       mobile: mobileNumber,
//     });
//     if (sendMessageErrors.mobile) {
//       setSendMessageErrors({});
//     }
//   };

//   const handleSendMessage = async () => {
//     if (!sendMessageForm.mobile.trim()) {
//       setSendMessageErrors({ mobile: t("common.mobileRequired") });
//       return;
//     }

//     setSendingMessage(true);
//     try {
//       // Build URL with query parameters (GET request)
//       const endpoint = `${API_ENDPOINTS.CLUB_MIGRATE_SEND_MESSAGE}/${sendMessageRecord.id}?country_code=${encodeURIComponent(
//         sendMessageForm.country_code,
//       )}&mobile=${encodeURIComponent(sendMessageForm.mobile)}`;
//       const response = await sendMessageGet(endpoint);

//       if (response?.status === true) {
//         Toast.success(response?.message || t("clubMigrate.messageSentSuccess"));
//         setIsSendMessageModalOpen(false);
//       } else {
//         Toast.error(response?.message || t("clubMigrate.messageSentFailed"));
//       }
//     } catch (error) {
//       console.error("Send message error:", error);
//       Toast.error(
//         error?.response?.data?.message || t("clubMigrate.messageSentFailed"),
//       );
//     } finally {
//       setSendingMessage(false);
//     }
//   };

//   // Helper functions
//   const getClubName = (clubId) => {
//     if (!clubId) return "N/A";
//     const club = clubsList.find((c) => c.id === clubId);
//     return club ? club.name : "N/A";
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     const date = new Date(dateString);
//     return date.toLocaleDateString(i18n.language === "nl" ? "nl-NL" : "en-US", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   };

//   const hasFilters = searchTerm || statusFilter;

//   // Table columns
//   const columns = [
//     {
//       title: t("common.sno"),
//       key: "sno",
//       width: 70,
//       render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
//     },
//     {
//       title: t("clubMigrate.couponCode"),
//       dataIndex: "coupon_code",
//       key: "coupon_code",
//       render: (text) => (
//         <Space>
//           <span>{text}</span>
//           <Tooltip title={t("common.copy")}>
//             <Button
//               type="text"
//               size="small"
//               icon={<CopyOutlined />}
//               onClick={() => handleCopyCoupon(text)}
//             />
//           </Tooltip>
//         </Space>
//       ),
//     },
//     {
//       title: t("clubMigrate.club"),
//       dataIndex: "club",
//       key: "club",
//       render: (clubId) => getClubName(clubId),
//     },
//     {
//       title: t("clubMigrate.assignedSlots"),
//       dataIndex: "assigned_slots",
//       key: "assigned_slots",
//     },
//     {
//       title: t("clubMigrate.freeUntil"),
//       dataIndex: "free_until",
//       key: "free_until",
//       render: (date) => (date ? formatDate(date) : "—"),
//     },
//     {
//       title: t("common.createdAt"),
//       dataIndex: "created_at",
//       key: "created_at",
//       render: (date) => formatDate(date),
//     },
//     {
//       title: t("common.status"),
//       dataIndex: "is_active",
//       key: "status",
//       width: 100,
//       render: (isActive) => (
//         <Tag color={isActive ? "green" : "default"}>
//           {isActive ? t("common.active") : t("common.inactive")}
//         </Tag>
//       ),
//     },
//     {
//       title: t("common.actions"),
//       key: "actions",
//       width: 250,
//       render: (_, record) => (
//         <Space size="small">
//           <Tooltip
//             title={record.is_active ? t("common.inactive") : t("common.active")}
//           >
//             <Button
//               size="small"
//               danger={!record.is_active}
//               type={record.is_active ? "default" : "primary"}
//               icon={<PoweroffOutlined />}
//               onClick={() => handleToggleActive(record)}
//               loading={updatingStatus}
//             />
//           </Tooltip>
//           <Tooltip title={t("common.view")}>
//             <Button
//               type="primary"
//               size="small"
//               icon={<EyeOutlined />}
//               onClick={() => openViewPage(record.id)}
//             />
//           </Tooltip>
//           <Tooltip title={t("common.edit")}>
//             <Button
//               type="primary"
//               size="small"
//               style={{ background: "#52c41a", borderColor: "#52c41a" }}
//               icon={<EditOutlined />}
//               onClick={() => openEditModal(record)}
//             />
//           </Tooltip>
//           <Tooltip title={t("clubMigrate.sendMessage")}>
//             <Button
//               type="primary"
//               size="small"
//               icon={<MessageOutlined />}
//               onClick={() => openSendMessageModal(record)}
//               style={{ background: "#1890ff", borderColor: "#1890ff" }}
//             />
//           </Tooltip>
//           <Tooltip title={t("common.delete")}>
//             <Button
//               danger
//               size="small"
//               icon={<DeleteOutlined />}
//               onClick={() => openDeleteModal(record)}
//             />
//           </Tooltip>
//         </Space>
//       ),
//     },
//   ];

//   // Phone input style override
//   const phoneInputStyle = {
//     width: "100%",
//     height: "40px",
//     border: "1px solid #d1d5db",
//     borderRadius: "6px",
//     paddingLeft: "48px",
//   };

//   return (
//     <>
//       <Card
//         title={t("clubMigrate.title")}
//         extra={
//           <Button type="primary" onClick={openCreateModal} disabled={loading}>
//             {t("clubMigrate.createNew")}
//           </Button>
//         }
//       >
//         {/* Filters */}
//         <div
//           style={{
//             display: "flex",
//             gap: "16px",
//             marginBottom: 16,
//             flexWrap: "wrap",
//           }}
//         >
//           <Input
//             placeholder={t("common.search")}
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             allowClear
//             style={{ width: 200 }}
//             disabled={loading}
//           />
//           <Select
//             placeholder={t("common.filterByStatus")}
//             value={statusFilter || undefined}
//             onChange={(value) => setStatusFilter(value || "")}
//             style={{ width: 150 }}
//             allowClear
//             disabled={loading}
//           >
//             {STATUS_OPTIONS.map((opt) => (
//               <Option key={opt.value} value={opt.value}>
//                 {opt.label}
//               </Option>
//             ))}
//           </Select>
//           {hasFilters && (
//             <Button onClick={resetFilters} disabled={loading}>
//               {t("common.clearSearchToReorder")}
//             </Button>
//           )}
//         </div>

//         {/* Table */}
//         <Table
//           columns={columns}
//           dataSource={clubMigrateList}
//           rowKey="id"
//           loading={loading}
//           pagination={{
//             current: currentPage,
//             pageSize: pageSize,
//             total: totalCount,
//             showSizeChanger: true,
//             pageSizeOptions: ["5", "10", "20", "50", "100"],
//             showTotal: (total) =>
//               `${t("common.showing")} ${(currentPage - 1) * pageSize + 1} ${t(
//                 "common.to",
//               )} ${Math.min(currentPage * pageSize, total)} ${t(
//                 "common.of",
//               )} ${total} ${t("common.entries")}`,
//             onChange: (page, size) => {
//               setCurrentPage(page);
//               setPageSize(size || 10);
//             },
//           }}
//           locale={{
//             emptyText: hasFilters
//               ? t("common.noMatchingEntries")
//               : t("clubMigrate.noRecordsFound"),
//           }}
//         />
//       </Card>

//       {/* Create/Edit Modal */}
//       {isModalOpen && (
//         <Modal
//           isOpen={isModalOpen}
//           onClose={() => {
//             setIsModalOpen(false);
//             resetForm();
//           }}
//           title={
//             isEditMode
//               ? t("clubMigrate.editTitle")
//               : t("clubMigrate.createTitle")
//           }
//           onConfirm={isEditMode ? handleUpdate : handleCreate}
//           confirmText={
//             isEditMode
//               ? submitting
//                 ? t("clubMigrate.savingChanges")
//                 : t("common.update")
//               : submitting
//                 ? t("clubMigrate.creating")
//                 : t("common.create")
//           }
//           confirmDisabled={submitting}
//           width={500}
//         >
//           <form onSubmit={isEditMode ? handleUpdate : handleCreate}>
//             {/* Club Selection */}
//             <div style={{ marginBottom: "15px" }}>
//               <label
//                 style={{
//                   display: "block",
//                   marginBottom: "5px",
//                   fontWeight: "500",
//                 }}
//               >
//                 {t("clubMigrate.club")} <span style={{ color: "red" }}>*</span>
//               </label>
//               <Select
//                 placeholder={t("clubMigrate.selectClub")}
//                 value={formData.club || undefined}
//                 onChange={(value) => handleInputChange("club", value)}
//                 style={{ width: "100%" }}
//                 disabled={submitting}
//                 status={formErrors.club ? "error" : ""}
//                 showSearch
//                 optionFilterProp="children"
//                 loading={loadingClubs}
//               >
//                 {clubsList.map((club) => (
//                   <Option key={club.id} value={club.id}>
//                     {club.name}
//                   </Option>
//                 ))}
//               </Select>
//               {formErrors.club && (
//                 <div
//                   style={{
//                     color: "#dc3545",
//                     fontSize: "12px",
//                     marginTop: "5px",
//                   }}
//                 >
//                   {formErrors.club}
//                 </div>
//               )}
//             </div>

//             {/* Assigned Slots */}
//             <div style={{ marginBottom: "15px" }}>
//               <label
//                 style={{
//                   display: "block",
//                   marginBottom: "5px",
//                   fontWeight: "500",
//                 }}
//               >
//                 {t("clubMigrate.assignedSlots")}{" "}
//                 <span style={{ color: "red" }}>*</span>
//               </label>
//               <Input
//                 type="number"
//                 min={0}
//                 value={formData.assigned_slots}
//                 onChange={(e) =>
//                   handleInputChange(
//                     "assigned_slots",
//                     parseInt(e.target.value) || 0,
//                   )
//                 }
//                 style={{ width: "100%" }}
//                 disabled={submitting}
//                 status={formErrors.assigned_slots ? "error" : ""}
//               />
//               {formErrors.assigned_slots && (
//                 <div
//                   style={{
//                     color: "#dc3545",
//                     fontSize: "12px",
//                     marginTop: "5px",
//                   }}
//                 >
//                   {formErrors.assigned_slots}
//                 </div>
//               )}
//             </div>

//             {/* Free Until Date */}
//             <div style={{ marginBottom: "15px" }}>
//               <label
//                 style={{
//                   display: "block",
//                   marginBottom: "5px",
//                   fontWeight: "500",
//                 }}
//               >
//                 {t("clubMigrate.freeUntil")}
//               </label>
//               <Input
//                 type="date"
//                 value={formData.free_until || ""}
//                 onChange={(e) =>
//                   handleInputChange("free_until", e.target.value || null)
//                 }
//                 style={{ width: "100%" }}
//                 disabled={submitting}
//               />
//             </div>

//             {/* Active Status */}
//             <div style={{ marginBottom: "15px" }}>
//               <label
//                 style={{ display: "flex", alignItems: "center", gap: "8px" }}
//               >
//                 <input
//                   type="checkbox"
//                   checked={formData.is_active}
//                   onChange={(e) =>
//                     handleInputChange("is_active", e.target.checked)
//                   }
//                   disabled={submitting}
//                 />
//                 <span>{t("common.active")}</span>
//               </label>
//             </div>
//           </form>
//         </Modal>
//       )}

//       {/* Delete Confirmation Modal */}
//       {isDeleteModalOpen && itemToDelete && (
//         <Modal
//           isOpen={isDeleteModalOpen}
//           onClose={() => {
//             setIsDeleteModalOpen(false);
//             setItemToDelete(null);
//           }}
//           title={t("clubMigrate.confirmDelete")}
//           onConfirm={handleDeleteConfirm}
//           confirmText={deleting ? t("common.loading") : t("common.delete")}
//           confirmColor="danger"
//           confirmDisabled={deleting}
//         >
//           <div style={{ textAlign: "center" }}>
//             <div style={{ fontSize: "40px", marginBottom: "10px" }}>⚠️</div>
//             <h3 style={{ marginBottom: "15px" }}>
//               {t("clubMigrate.confirmDelete")}
//             </h3>
//             <div
//               style={{
//                 textAlign: "left",
//                 backgroundColor: "#f8f9fa",
//                 padding: "15px",
//                 borderRadius: "6px",
//                 marginBottom: "15px",
//               }}
//             >
//               <p>
//                 <strong>{t("clubMigrate.couponCode")}:</strong>{" "}
//                 {itemToDelete.coupon_code}
//               </p>
//               <p>
//                 <strong>{t("clubMigrate.club")}:</strong>{" "}
//                 {getClubName(itemToDelete.club)}
//               </p>
//               <p>
//                 <strong>{t("clubMigrate.assignedSlots")}:</strong>{" "}
//                 {itemToDelete.assigned_slots}
//               </p>
//               <p>
//                 <strong>{t("clubMigrate.freeUntil")}:</strong>{" "}
//                 {itemToDelete.free_until
//                   ? formatDate(itemToDelete.free_until)
//                   : "—"}
//               </p>
//               <p>
//                 <strong>{t("common.createdAt")}:</strong>{" "}
//                 {formatDate(itemToDelete.created_at)}
//               </p>
//               <p>
//                 <strong>{t("common.status")}:</strong>
//                 <Tag
//                   color={itemToDelete.is_active ? "green" : "default"}
//                   style={{ marginLeft: "10px" }}
//                 >
//                   {itemToDelete.is_active
//                     ? t("common.active")
//                     : t("common.inactive")}
//                 </Tag>
//               </p>
//             </div>
//             <p style={{ color: "#dc3545" }}>{t("clubMigrate.deleteWarning")}</p>
//           </div>
//         </Modal>
//       )}

//       {/* Send Message Modal */}
//       {isSendMessageModalOpen && sendMessageRecord && (
//         <AntModal
//           title={t("clubMigrate.sendMessageTo", {
//             club: getClubName(sendMessageRecord.club),
//           })}
//           open={isSendMessageModalOpen}
//           onCancel={() => setIsSendMessageModalOpen(false)}
//           footer={[
//             <Button
//               key="cancel"
//               onClick={() => setIsSendMessageModalOpen(false)}
//             >
//               {t("common.cancel")}
//             </Button>,
//             <Button
//               key="send"
//               type="primary"
//               loading={sendingMessage}
//               onClick={handleSendMessage}
//             >
//               {t("clubMigrate.sendMessage")}
//             </Button>,
//           ]}
//           width={400}
//         >
//           <div style={{ marginBottom: "15px" }}>
//             <label
//               style={{
//                 display: "block",
//                 marginBottom: "5px",
//                 fontWeight: "500",
//               }}
//             >
//               {t("common.mobileNumber")} <span style={{ color: "red" }}>*</span>
//             </label>
//             <PhoneInput
//               country={"nl"}
//               value={sendMessageForm.country_code + sendMessageForm.mobile}
//               onChange={handlePhoneChange}
//               inputProps={{
//                 name: "mobile",
//                 required: true,
//               }}
//               inputStyle={{
//                 ...phoneInputStyle,
//                 border: sendMessageErrors.mobile
//                   ? "1px solid #dc3545"
//                   : "1px solid #d1d5db",
//               }}
//               containerStyle={{ width: "100%" }}
//               buttonStyle={{
//                 border: sendMessageErrors.mobile
//                   ? "1px solid #dc3545"
//                   : "1px solid #d1d5db",
//                 borderRight: "none",
//                 borderTopLeftRadius: "6px",
//                 borderBottomLeftRadius: "6px",
//                 background: "#f9fafb",
//               }}
//               dropdownStyle={{
//                 width: "300px",
//                 borderRadius: "6px",
//               }}
//               enableSearch={true}
//               searchPlaceholder={t("common.search")}
//               placeholder={t("common.enterMobileNumber")}
//               disableSearchIcon={false}
//               countryCodeEditable={false}
//             />
//             {sendMessageErrors.mobile && (
//               <div
//                 style={{
//                   color: "#dc3545",
//                   fontSize: "12px",
//                   marginTop: "5px",
//                 }}
//               >
//                 {sendMessageErrors.mobile}
//               </div>
//             )}
//           </div>
//         </AntModal>
//       )}
//     </>
//   );
// };

// export default ClubMigrateManager;

import React, { useState, useEffect } from "react";
import {
  Card,
  Input,
  Button,
  Select,
  Table,
  Tag,
  Space,
  Tooltip,
  Modal as AntModal,
  message as antdMessage,
} from "antd";
import {
  EyeOutlined,
  EditOutlined,
  DeleteOutlined,
  PoweroffOutlined,
  CopyOutlined,
  MessageOutlined,
} from "@ant-design/icons";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import dayjs from "dayjs";
import Modal from "../../components/Modal";
import { useGet, usePost, useDynamicApi } from "../../hooks/useApi";
import { useDebounce } from "../../hooks/useDebounce";
import { API_ENDPOINTS } from "../../config/api";
import Toast from "../../utils/toast";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const { Option } = Select;

const ClubMigrateManager = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  // Modal states
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  // Send Message Modal states
  const [isSendMessageModalOpen, setIsSendMessageModalOpen] = useState(false);
  const [sendMessageRecord, setSendMessageRecord] = useState(null);
  const [sendMessageForm, setSendMessageForm] = useState({
    country_code: "+31",
    mobile: "",
  });
  const [sendingMessage, setSendingMessage] = useState(false);
  const [sendMessageErrors, setSendMessageErrors] = useState({});

  // Form data state
  const [formData, setFormData] = useState({
    club: "",
    assigned_slots: 0,
    free_until: null,
    is_active: true,
  });

  // Form validation errors
  const [formErrors, setFormErrors] = useState({});

  // Filter states
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  // Data states
  const [clubMigrateList, setClubMigrateList] = useState([]);
  const [clubsList, setClubsList] = useState([]);
  const [loadingClubs, setLoadingClubs] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  // Constants
  const STATUS_OPTIONS = [
    { value: "active", label: t("common.active") },
    { value: "inactive", label: t("common.inactive") },
  ];

  // API hooks
  const { execute: fetchList, loading: loadingList } = useGet(
    `${API_ENDPOINTS.CLUB_MIGRATE_LIST}?page=${currentPage}&page_size=${pageSize}&search=${debouncedSearchTerm}&status=${statusFilter || ""}`,
  );

  const { post, loading: creating } = usePost(
    API_ENDPOINTS.CLUB_MIGRATE_CREATE,
  );
  const { execute: getById, loading: loadingById } = useDynamicApi("GET");
  const { execute: putData, loading: updating } = useDynamicApi("PUT");
  const { execute: patchData, loading: updatingStatus } =
    useDynamicApi("PATCH");
  const { execute: deleteData, loading: deleting } = useDynamicApi("DELETE");
  const { execute: fetchClubsList } = useGet(
    API_ENDPOINTS.CLUBS_LIST_WITHOUT_PAGINATE,
  );
  const { execute: sendMessageGet, loading: sendingMessageLoading } =
    useDynamicApi("GET");

  const loading =
    loadingList ||
    loadingById ||
    updating ||
    updatingStatus ||
    deleting ||
    creating ||
    loadingClubs ||
    submitting ||
    sendingMessageLoading;

  const loadClubsList = async () => {
    setLoadingClubs(true);
    try {
      const response = await fetchClubsList();
      if (response?.status === true && response.data) {
        setClubsList(response.data);
      } else {
        setClubsList([]);
      }
    } catch (error) {
      console.error("Error loading clubs:", error);
      setClubsList([]);
    } finally {
      setLoadingClubs(false);
    }
  };

  const loadData = async () => {
    try {
      const response = await fetchList();
      if (response) {
        setClubMigrateList(response.data || []);
        setTotalCount(response.pagination?.total_count || 0);
      }
    } catch (error) {
      console.error("Error loading data:", error);
    }
  };

  useEffect(() => {
    loadData();
    loadClubsList();
  }, [currentPage, pageSize]);

  useEffect(() => {
    setCurrentPage(1);
    loadData();
  }, [debouncedSearchTerm, statusFilter]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (formErrors[field]) {
      setFormErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };

  const resetForm = () => {
    setFormData({
      club: "",
      assigned_slots: 0,
      free_until: null,
      is_active: true,
    });
    setFormErrors({});
    setSelectedItem(null);
    setIsEditMode(false);
  };

  const resetFilters = () => {
    setSearchTerm("");
    setStatusFilter("");
  };

  // Validate form with free_until required
  const validateForm = () => {
    const errors = {};

    if (!formData.club) {
      errors.club = t("clubMigrate.clubRequired");
    }

    if (
      formData.assigned_slots === undefined ||
      formData.assigned_slots === null ||
      formData.assigned_slots < 0
    ) {
      errors.assigned_slots = t("clubMigrate.assignedSlotsRequired");
    }

    if (!formData.free_until) {
      errors.free_until = t("clubMigrate.freeUntilRequired");
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleCreate = async (e) => {
    e?.preventDefault?.();
    if (!validateForm()) return;

    setSubmitting(true);
    try {
      const payload = {
        club: formData.club,
        assigned_slots: formData.assigned_slots,
        free_until: dayjs(formData.free_until).format("YYYY-MM-DD"),
        is_active: formData.is_active,
      };
      const response = await post(payload);

      if (response?.status === true) {
        Toast.success(response?.message || t("clubMigrate.createdSuccess"));
        await loadData();
        setIsModalOpen(false);
        resetForm();
      } else {
        if (response?.errors) {
          setFormErrors(response.errors);
        } else {
          Toast.error(response?.message || t("clubMigrate.failedCreate"));
        }
      }
    } catch (error) {
      console.error("Error creating:", error);
      if (error?.response?.data?.errors) {
        setFormErrors(error.response.data.errors);
      } else {
        Toast.error(
          error?.response?.data?.message ||
            error.message ||
            t("clubMigrate.failedCreate"),
        );
      }
    } finally {
      setSubmitting(false);
    }
  };

  const handleUpdate = async (e) => {
    e?.preventDefault?.();
    if (!validateForm()) return;

    setSubmitting(true);
    try {
      const endpoint = `${API_ENDPOINTS.CLUB_MIGRATE_DETAIL}/${selectedItem.id}`;
      const payload = {
        club: formData.club,
        assigned_slots: formData.assigned_slots,
        free_until: dayjs(formData.free_until).format("YYYY-MM-DD"),
        is_active: formData.is_active,
      };
      const response = await putData(endpoint, payload);

      if (response?.status === true) {
        Toast.success(response?.message || t("clubMigrate.updatedSuccess"));
        await loadData();
        setIsModalOpen(false);
        resetForm();
      } else {
        if (response?.errors) {
          setFormErrors(response.errors);
        } else {
          Toast.error(response?.message || t("clubMigrate.failedUpdate"));
        }
      }
    } catch (error) {
      console.error("Error updating:", error);
      if (error?.response?.data?.errors) {
        setFormErrors(error.response.data.errors);
      } else {
        Toast.error(
          error?.response?.data?.message ||
            error.message ||
            t("clubMigrate.failedUpdate"),
        );
      }
    } finally {
      setSubmitting(false);
    }
  };

  const handleToggleActive = async (item) => {
    try {
      const newStatus = !item.is_active;
      const endpoint = `${API_ENDPOINTS.CLUB_MIGRATE_DETAIL}/${item.id}`;
      const response = await patchData(endpoint, { is_active: newStatus });

      if (response?.status === true) {
        Toast.success(
          response?.message ||
            (newStatus ? t("common.active") : t("common.inactive")),
        );
        await loadData();
      } else {
        Toast.error(response?.message || t("clubMigrate.failedUpdateStatus"));
      }
    } catch (error) {
      console.error("Error updating status:", error);
      Toast.error(error.message || t("clubMigrate.failedUpdateStatus"));
    }
  };

  const openDeleteModal = (item) => {
    setItemToDelete(item);
    setIsDeleteModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    if (!itemToDelete) return;

    try {
      const endpoint = `${API_ENDPOINTS.CLUB_MIGRATE_DETAIL}/${itemToDelete.id}`;
      const response = await deleteData(endpoint);

      if (response?.status === true) {
        Toast.success(response?.message || t("clubMigrate.deletedSuccess"));
        await loadData();
      } else {
        Toast.error(response?.message || t("clubMigrate.failedDelete"));
      }
    } catch (error) {
      console.error("Error deleting:", error);
      Toast.error(error.message || t("clubMigrate.failedDelete"));
    } finally {
      setIsDeleteModalOpen(false);
      setItemToDelete(null);
    }
  };

  const openCreateModal = () => {
    resetForm();
    setIsEditMode(false);
    setIsModalOpen(true);
  };

  const openEditModal = async (item) => {
    try {
      const endpoint = `${API_ENDPOINTS.CLUB_MIGRATE_DETAIL}/${item.id}`;
      const response = await getById(endpoint);

      if (response?.status === true && response.data) {
        setSelectedItem(response.data);
        setFormData({
          club: response.data.club || "",
          assigned_slots: response.data.assigned_slots || 0,
          free_until: response.data.free_until
            ? dayjs(response.data.free_until)
            : null,
          is_active: response.data.is_active,
        });
        setIsEditMode(true);
        setIsModalOpen(true);
      } else {
        Toast.error(t("clubMigrate.failedFetchDetails"));
      }
    } catch (error) {
      console.error("Error fetching details:", error);
      Toast.error(error.message || t("clubMigrate.failedFetchDetails"));
    }
  };

  const openViewPage = (id) => {
    navigate(`/clubmigrate/details/${id}`);
  };

  const handleCopyCoupon = (code) => {
    navigator.clipboard.writeText(code);
    antdMessage.success(t("common.copied"));
  };

  const openSendMessageModal = (record) => {
    setSendMessageRecord(record);
    setSendMessageForm({ country_code: "+31", mobile: "" });
    setSendMessageErrors({});
    setIsSendMessageModalOpen(true);
  };

  const handlePhoneChange = (value, country) => {
    const dialCode = `+${country.dialCode}`;
    const mobileNumber = value.substring(country.dialCode.length);
    setSendMessageForm({
      country_code: dialCode,
      mobile: mobileNumber,
    });
    if (sendMessageErrors.mobile) {
      setSendMessageErrors({});
    }
  };

  const handleSendMessage = async () => {
    if (!sendMessageForm.mobile.trim()) {
      setSendMessageErrors({ mobile: t("common.mobileRequired") });
      return;
    }

    setSendingMessage(true);
    try {
      const endpoint = `${API_ENDPOINTS.CLUB_MIGRATE_SEND_MESSAGE}/${sendMessageRecord.id}?country_code=${encodeURIComponent(
        sendMessageForm.country_code,
      )}&mobile=${encodeURIComponent(sendMessageForm.mobile)}`;
      const response = await sendMessageGet(endpoint);

      if (response?.status === true) {
        Toast.success(response?.message || t("clubMigrate.messageSentSuccess"));
        setIsSendMessageModalOpen(false);
      } else {
        Toast.error(response?.message || t("clubMigrate.messageSentFailed"));
      }
    } catch (error) {
      console.error("Send message error:", error);
      Toast.error(
        error?.response?.data?.message || t("clubMigrate.messageSentFailed"),
      );
    } finally {
      setSendingMessage(false);
    }
  };

  const getClubName = (clubId) => {
    if (!clubId) return "N/A";
    const club = clubsList.find((c) => c.id === clubId);
    return club ? club.name : "N/A";
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString(i18n.language === "nl" ? "nl-NL" : "en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const hasFilters = searchTerm || statusFilter;

  const columns = [
    {
      title: t("common.sno"),
      key: "sno",
      width: 70,
      render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: t("clubMigrate.couponCode"),
      dataIndex: "coupon_code",
      key: "coupon_code",
      render: (text) => (
        <Space>
          <span>{text}</span>
          <Tooltip title={t("common.copy")}>
            <Button
              type="text"
              size="small"
              icon={<CopyOutlined />}
              onClick={() => handleCopyCoupon(text)}
            />
          </Tooltip>
        </Space>
      ),
    },
    {
      title: t("clubMigrate.club"),
      dataIndex: "club",
      key: "club",
      render: (clubId) => getClubName(clubId),
    },
    {
      title: t("clubMigrate.assignedSlots"),
      dataIndex: "assigned_slots",
      key: "assigned_slots",
    },
    {
      title: t("clubMigrate.freeUntil"),
      dataIndex: "free_until",
      key: "free_until",
      render: (date) => (date ? formatDate(date) : "—"),
    },
    {
      title: t("common.createdAt"),
      dataIndex: "created_at",
      key: "created_at",
      render: (date) => formatDate(date),
    },
    {
      title: t("common.status"),
      dataIndex: "is_active",
      key: "status",
      width: 100,
      render: (isActive) => (
        <Tag color={isActive ? "green" : "default"}>
          {isActive ? t("common.active") : t("common.inactive")}
        </Tag>
      ),
    },
    {
      title: t("common.actions"),
      key: "actions",
      width: 250,
      render: (_, record) => (
        <Space size="small">
          <Tooltip
            title={record.is_active ? t("common.inactive") : t("common.active")}
          >
            <Button
              size="small"
              danger={!record.is_active}
              type={record.is_active ? "default" : "primary"}
              icon={<PoweroffOutlined />}
              onClick={() => handleToggleActive(record)}
              loading={updatingStatus}
            />
          </Tooltip>
          <Tooltip title={t("common.view")}>
            <Button
              type="primary"
              size="small"
              icon={<EyeOutlined />}
              onClick={() => openViewPage(record.id)}
            />
          </Tooltip>
          <Tooltip title={t("common.edit")}>
            <Button
              type="primary"
              size="small"
              style={{ background: "#52c41a", borderColor: "#52c41a" }}
              icon={<EditOutlined />}
              onClick={() => openEditModal(record)}
            />
          </Tooltip>
          <Tooltip title={t("clubMigrate.sendMessage")}>
            <Button
              type="primary"
              size="small"
              icon={<MessageOutlined />}
              onClick={() => openSendMessageModal(record)}
              style={{ background: "#1890ff", borderColor: "#1890ff" }}
            />
          </Tooltip>
          <Tooltip title={t("common.delete")}>
            <Button
              danger
              size="small"
              icon={<DeleteOutlined />}
              onClick={() => openDeleteModal(record)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const phoneInputStyle = {
    width: "100%",
    height: "40px",
    border: "1px solid #d1d5db",
    borderRadius: "6px",
    paddingLeft: "48px",
  };

  return (
    <>
      <Card
        title={t("clubMigrate.title")}
        extra={
          <Button type="primary" onClick={openCreateModal} disabled={loading}>
            {t("clubMigrate.createNew")}
          </Button>
        }
      >
        <div
          style={{
            display: "flex",
            gap: "16px",
            marginBottom: 16,
            flexWrap: "wrap",
          }}
        >
          <Input
            placeholder={t("common.search")}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            allowClear
            style={{ width: 200 }}
            disabled={loading}
          />
          <Select
            placeholder={t("common.filterByStatus")}
            value={statusFilter || undefined}
            onChange={(value) => setStatusFilter(value || "")}
            style={{ width: 150 }}
            allowClear
            disabled={loading}
          >
            {STATUS_OPTIONS.map((opt) => (
              <Option key={opt.value} value={opt.value}>
                {opt.label}
              </Option>
            ))}
          </Select>
          {hasFilters && (
            <Button onClick={resetFilters} disabled={loading}>
              {t("common.clearSearchToReorder")}
            </Button>
          )}
        </div>

        <Table
          columns={columns}
          dataSource={clubMigrateList}
          rowKey="id"
          loading={loading}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalCount,
            showSizeChanger: true,
            pageSizeOptions: ["5", "10", "20", "50", "100"],
            showTotal: (total) =>
              `${t("common.showing")} ${(currentPage - 1) * pageSize + 1} ${t(
                "common.to",
              )} ${Math.min(currentPage * pageSize, total)} ${t(
                "common.of",
              )} ${total} ${t("common.entries")}`,
            onChange: (page, size) => {
              setCurrentPage(page);
              setPageSize(size || 10);
            },
          }}
          locale={{
            emptyText: hasFilters
              ? t("common.noMatchingEntries")
              : t("clubMigrate.noRecordsFound"),
          }}
        />
      </Card>

      {/* Create/Edit Modal */}
      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
            resetForm();
          }}
          title={
            isEditMode
              ? t("clubMigrate.editTitle")
              : t("clubMigrate.createTitle")
          }
          onConfirm={isEditMode ? handleUpdate : handleCreate}
          confirmText={
            isEditMode
              ? submitting
                ? t("clubMigrate.savingChanges")
                : t("common.update")
              : submitting
                ? t("clubMigrate.creating")
                : t("common.create")
          }
          confirmDisabled={submitting}
          width={500}
        >
          <form onSubmit={isEditMode ? handleUpdate : handleCreate}>
            {/* Club Selection */}
            <div style={{ marginBottom: "15px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "500",
                }}
              >
                {t("clubMigrate.club")} <span style={{ color: "red" }}>*</span>
              </label>
              <Select
                placeholder={t("clubMigrate.selectClub")}
                value={formData.club || undefined}
                onChange={(value) => handleInputChange("club", value)}
                style={{ width: "100%" }}
                disabled={submitting}
                status={formErrors.club ? "error" : ""}
                showSearch
                optionFilterProp="children"
                loading={loadingClubs}
              >
                {clubsList.map((club) => (
                  <Option key={club.id} value={club.id}>
                    {club.name}
                  </Option>
                ))}
              </Select>
              {formErrors.club && (
                <div
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "5px",
                  }}
                >
                  {formErrors.club}
                </div>
              )}
            </div>

            {/* Assigned Slots */}
            <div style={{ marginBottom: "15px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "500",
                }}
              >
                {t("clubMigrate.assignedSlots")}{" "}
                <span style={{ color: "red" }}>*</span>
              </label>
              <Input
                type="number"
                min={0}
                value={formData.assigned_slots}
                onChange={(e) =>
                  handleInputChange(
                    "assigned_slots",
                    parseInt(e.target.value) || 0,
                  )
                }
                style={{ width: "100%" }}
                disabled={submitting}
                status={formErrors.assigned_slots ? "error" : ""}
              />
              {formErrors.assigned_slots && (
                <div
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "5px",
                  }}
                >
                  {formErrors.assigned_slots}
                </div>
              )}
            </div>

            {/* Free Until Date - Now Required */}
            <div style={{ marginBottom: "15px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "500",
                }}
              >
                {t("clubMigrate.freeUntil")}{" "}
                <span style={{ color: "red" }}>*</span>
              </label>
              <Input
                type="date"
                value={formData.free_until || ""}
                onChange={(e) =>
                  handleInputChange("free_until", e.target.value || null)
                }
                style={{ width: "100%" }}
                disabled={submitting}
                status={formErrors.free_until ? "error" : ""}
              />
              {formErrors.free_until && (
                <div
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "5px",
                  }}
                >
                  {formErrors.free_until}
                </div>
              )}
            </div>

            {/* Active Status */}
            <div style={{ marginBottom: "15px" }}>
              <label
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <input
                  type="checkbox"
                  checked={formData.is_active}
                  onChange={(e) =>
                    handleInputChange("is_active", e.target.checked)
                  }
                  disabled={submitting}
                />
                <span>{t("common.active")}</span>
              </label>
            </div>
          </form>
        </Modal>
      )}

      {/* Delete Confirmation Modal (unchanged) */}
      {isDeleteModalOpen && itemToDelete && (
        <Modal
          isOpen={isDeleteModalOpen}
          onClose={() => {
            setIsDeleteModalOpen(false);
            setItemToDelete(null);
          }}
          title={t("clubMigrate.confirmDelete")}
          onConfirm={handleDeleteConfirm}
          confirmText={deleting ? t("common.loading") : t("common.delete")}
          confirmColor="danger"
          confirmDisabled={deleting}
        >
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "40px", marginBottom: "10px" }}>⚠️</div>
            <h3 style={{ marginBottom: "15px" }}>
              {t("clubMigrate.confirmDelete")}
            </h3>
            <div
              style={{
                textAlign: "left",
                backgroundColor: "#f8f9fa",
                padding: "15px",
                borderRadius: "6px",
                marginBottom: "15px",
              }}
            >
              <p>
                <strong>{t("clubMigrate.couponCode")}:</strong>{" "}
                {itemToDelete.coupon_code}
              </p>
              <p>
                <strong>{t("clubMigrate.club")}:</strong>{" "}
                {getClubName(itemToDelete.club)}
              </p>
              <p>
                <strong>{t("clubMigrate.assignedSlots")}:</strong>{" "}
                {itemToDelete.assigned_slots}
              </p>
              <p>
                <strong>{t("clubMigrate.freeUntil")}:</strong>{" "}
                {itemToDelete.free_until
                  ? formatDate(itemToDelete.free_until)
                  : "—"}
              </p>
              <p>
                <strong>{t("common.createdAt")}:</strong>{" "}
                {formatDate(itemToDelete.created_at)}
              </p>
              <p>
                <strong>{t("common.status")}:</strong>
                <Tag
                  color={itemToDelete.is_active ? "green" : "default"}
                  style={{ marginLeft: "10px" }}
                >
                  {itemToDelete.is_active
                    ? t("common.active")
                    : t("common.inactive")}
                </Tag>
              </p>
            </div>
            <p style={{ color: "#dc3545" }}>{t("clubMigrate.deleteWarning")}</p>
          </div>
        </Modal>
      )}

      {/* Send Message Modal (unchanged) */}
      {isSendMessageModalOpen && sendMessageRecord && (
        <AntModal
          title={t("clubMigrate.sendMessageTo", {
            club: getClubName(sendMessageRecord.club),
          })}
          open={isSendMessageModalOpen}
          onCancel={() => setIsSendMessageModalOpen(false)}
          footer={[
            <Button
              key="cancel"
              onClick={() => setIsSendMessageModalOpen(false)}
            >
              {t("common.cancel")}
            </Button>,
            <Button
              key="send"
              type="primary"
              loading={sendingMessage}
              onClick={handleSendMessage}
            >
              {t("clubMigrate.sendMessage")}
            </Button>,
          ]}
          width={400}
        >
          <div style={{ marginBottom: "15px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "5px",
                fontWeight: "500",
              }}
            >
              {t("common.mobileNumber")} <span style={{ color: "red" }}>*</span>
            </label>
            <PhoneInput
              country={"nl"}
              value={sendMessageForm.country_code + sendMessageForm.mobile}
              onChange={handlePhoneChange}
              inputProps={{
                name: "mobile",
                required: true,
              }}
              inputStyle={{
                ...phoneInputStyle,
                border: sendMessageErrors.mobile
                  ? "1px solid #dc3545"
                  : "1px solid #d1d5db",
              }}
              containerStyle={{ width: "100%" }}
              buttonStyle={{
                border: sendMessageErrors.mobile
                  ? "1px solid #dc3545"
                  : "1px solid #d1d5db",
                borderRight: "none",
                borderTopLeftRadius: "6px",
                borderBottomLeftRadius: "6px",
                background: "#f9fafb",
              }}
              dropdownStyle={{
                width: "300px",
                borderRadius: "6px",
              }}
              enableSearch={true}
              searchPlaceholder={t("common.search")}
              placeholder={t("common.enterMobileNumber")}
              disableSearchIcon={false}
              countryCodeEditable={false}
            />
            {sendMessageErrors.mobile && (
              <div
                style={{
                  color: "#dc3545",
                  fontSize: "12px",
                  marginTop: "5px",
                }}
              >
                {sendMessageErrors.mobile}
              </div>
            )}
          </div>
        </AntModal>
      )}
    </>
  );
};

export default ClubMigrateManager;
